<template>
  <div :class="className">
    <MainButton v-if="authList.includes('steam')" theme="cta" :size="buttonSize" @click="authSteam()">
      <img :src="require('../images/logo-steam.svg')" alt="steam logo">
    </MainButton>
    <MainButton v-if="authList.includes('ps')" theme="cta" :size="buttonSize" @click="authPS()">
      <img :src="require('../images/logo-ps.svg')" alt="playstation logo">
    </MainButton>
    <MainButton v-if="authList.includes('xbox')" theme="cta" :size="buttonSize" @click="authXbox()">
      <img :src="require('../images/logo-xbox.svg')" alt="xbox logo">
    </MainButton>
    <MainButton v-if="isMgButtonShown" theme="cta" :size="buttonSize" @click="playMyGames()">
      <img :src="require('../images/logo-mygames.svg')" alt="mygames logo">
    </MainButton>
  </div>
</template>

<script>
import MainButton from "@static_promo_pages/common/components/redesign/main-button/vue/MainButton.vue";
import DeviceDetectionMixin from "@godweb/frontend-base/src/mixins/mobile_detection/DeviceDetectionMixin";
import LoginAndDownloadMixin from "@static_promo_pages/common/mixins/LoginAndDownloadMixin";

export default {
  name: "AuthButtons",
  components: {
    MainButton,
  },
  mixins: [DeviceDetectionMixin, LoginAndDownloadMixin],
  props: {
    size: {
      type: String,
      default: "small", // small, extra-small
    },
    showMgButtonOnlyForPc: {
      type: Boolean,
      default: false,
    },
    authList: {
      type: Array,
      default: () => ["mg", "steam", "ps", "xbox"],
    },

    // if need logout user when button smash
    needLogout: {
      type: Boolean,
      default: false,
    },

    // if need to open MG form without session
    needChangeAccount: {
      type: Boolean,
      default: false,
    },

    // click on mygames button download or auth
    mgDownload: {
      type: Boolean,
      default: false,
    },

    // For the cases where we should show MG auth window
    withoutMgAuth: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    className() {
      return [
        "auth-buttons",
        `auth-buttons--${this.size}`,
      ];
    },
    buttonSize() {
      return this.size === "small" ? "mobile-small" : "mobile-extra-small";
    },
    isMgButtonShown() {
      if (!this.authList.includes("mg")) {
        return false;
      }
      return !this.showMgButtonOnlyForPc || this.canInstallNewLauncher;
    },
    isUserNeedLogout() {
      return this.isUserInProject && this.needLogout;
    },
  },
  methods: {
    async authSteam() {
      if (this.isUserNeedLogout) {
        await this.$authService.logout(false);
      }
      this.$oneLinkEventSender.sendEvent("login.steam");
      this.$authService.showSteamSignin();
    },
    async authPS() {
      if (this.isUserNeedLogout) {
        await this.$authService.logout(false);
      }
      this.$oneLinkEventSender.sendEvent("login.ps");
      this.$authService.showPsSignin();
    },
    async authXbox() {
      if (this.isUserNeedLogout) {
        await this.$authService.logout(false);
      }
      this.$oneLinkEventSender.sendEvent("login.xbox");
      this.$authService.showXboxSignin();
    },
    playMyGames() {
      this.$emit("mgButtonClicked");

      if (this.withoutMgAuth) return;

      if (this.mgDownload) {
        this.$oneLinkEventSender.sendEvent("login.mygamesdownload");
        this.$oneLinkEventSender.sendEvent("play");
        this.gameDownload("", false, false);
        this.$emit("startDownload");
      } else {
        this.$oneLinkEventSender.sendEvent("login.mygames");

        this.needChangeAccount ? this.$authService.showChangeAccount() : this.$authService.showSignin();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles";
</style>
